import { useEffect } from 'react';

//Note: use mouseDown event in child click of ref div. See dashboardList.tsx for more info
const useOnClickOutside = (ref: any, handler: (event: any) => void) => {
	useEffect(() => {
		const listener = (event: any) => {
			// Do nothing if clicking ref's element or descendent elements
			if (!ref.current || ref.current.contains(event.target)) {
				return;
			}
			handler(event);
		};
		document.addEventListener('mousedown', listener);
		return () => {
			document.removeEventListener('mousedown', listener);
		};
	}, [ref, handler]);
};

export default useOnClickOutside;
